module.exports = require('./helpers/bundle-url').getBundleURL('37SUZ') + "logo-dark.ba5147f0.svg";